import { LocaleCurrency } from 'types/Shared/Locale'
import { convertDefaultToLocaleCurrency, getCurrencySymbol } from 'components/FormatPrice/helpers'

export const getPriceLabel = (selectedCurrency: LocaleCurrency, priceValue: string): string => {
  const currencySymbol = getCurrencySymbol(selectedCurrency)
  const priceMappingObject = {
    '0-500': `Under ${currencySymbol}500`,
    '0-200': `Under ${currencySymbol}200`,
    '500': `Over ${currencySymbol}500`,
    '10000-500000': `Over ${currencySymbol}10,000`,
  }
  const splitPrice = priceValue.split('-')
  const price = splitPrice.map((value) =>
    convertDefaultToLocaleCurrency(parseInt(value, 10), selectedCurrency)
  )
  const priceString = price.join('-')
  const priceTitle = Object.keys(priceMappingObject).some((ele) => ele === priceString)
    ? priceMappingObject[priceString]
    : `${currencySymbol}${price[0]} - ${currencySymbol}${price[1]}`
  return priceTitle
}
